export enum CacheGroup {
  APCU = 'apcu',
  FILE = 'file',
  INTEGRATION = 'integration',
  REDIS = 'redis',
}

export enum CacheImpact {
  HIGH = 'high',
  LOW = 'low',
  MEDIUM = 'medium',
}

export enum ConsumerJobStatus {
  QUEUED = 'queued',
  RUNNING = 'running',
}

export enum SubmitOrderOutcome {
  FAILED = 'failed',
  NO_RESPONSE = 'no_response',
  SUCCESS = 'success',
}

export enum VendorQuoteImportAnomaly {
  DOUBLE_PERSIST = 'double_persist',
  NO_PARTS_IMPORTED = 'no_parts_imported',
  ROWS_SKIPPED = 'rows_skipped',
  STALE_ROWS_CLEARED = 'stale_rows_cleared',
}

export enum VendorQuoteImportDeliveredVia {
  POLL = 'poll',
  PUSH = 'push',
}

export enum VendorQuoteImportManufacturerStatus {
  DISCOUNTS_ONLY = 'discounts_only',
  NO_MANUFACTURER = 'no_manufacturer',
  NOT_PERSISTED = 'not_persisted',
  RESOLVED = 'resolved',
}

export enum VendorQuoteImportOutcome {
  FAILED = 'failed',
  IN_PROGRESS = 'in-progress',
  SUCCESS = 'success',
}
